import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import {
  IbContestInternalResultsFilterKey,
  MarginBonusResultsFilterKey,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { MarketingCampaignType } from '../../../api/Trading-Accounts/Types/MarketingCampaignType'
import { LuckyDrawActivityFilter, MultiCountrySelectFilter } from '../common.filter'
import { MarginBonusStatusFilter } from './MarginBonusStatusFilter'

export const getCampaignResultFields = (campaignType: MarketingCampaignType): FieldSettings[] => {
  if (campaignType === MarketingCampaignType.MarginBonus) {
    return [
      {
        name: MarginBonusResultsFilterKey.clientName,
        label: 'Client Name',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.likeOperator,
            operator: GridFilterOperatorEnum.likeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notLikeOperator,
            operator: GridFilterOperatorEnum.notLikeOperator,
          },
        ],
      },
      {
        name: MarginBonusResultsFilterKey.account,
        label: 'Account',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.likeOperator,
            operator: GridFilterOperatorEnum.likeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notLikeOperator,
            operator: GridFilterOperatorEnum.notLikeOperator,
          },
        ],
      },
      {
        name: MarginBonusResultsFilterKey.netDeposit,
        label: 'Net Deposit',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.gtOperator,
            operator: GridFilterOperatorEnum.afterOperator,
          },
          {
            text: GridFilterOperatorNameEnum.gteOperator,
            operator: GridFilterOperatorEnum.afterOrEqualOperator,
          },
          {
            text: GridFilterOperatorNameEnum.ltOperator,
            operator: GridFilterOperatorEnum.beforeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.lteOperator,
            operator: GridFilterOperatorEnum.beforeOrEqualOperator,
          },
        ],
      },
      {
        name: MarginBonusResultsFilterKey.status,
        label: 'Status',
        filter: MarginBonusStatusFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
        ],
      },
    ]
  }
  if (campaignType === MarketingCampaignType.LuckyDraw) {
    return [
      {
        name: IbContestInternalResultsFilterKey.clientName,
        label: 'Client Name',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.likeOperator,
            operator: GridFilterOperatorEnum.likeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notLikeOperator,
            operator: GridFilterOperatorEnum.notLikeOperator,
          },
        ],
      },
      {
        name: 'Activity',
        label: 'Activity',
        filter: LuckyDrawActivityFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
        ],
      },
      {
        name: 'Amount',
        label: 'Amount',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
        ],
      },
      {
        name: 'ResultType',
        label: 'Result Type',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.likeOperator,
            operator: GridFilterOperatorEnum.likeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notLikeOperator,
            operator: GridFilterOperatorEnum.notLikeOperator,
          },
        ],
      },
    ]
  }
  if (campaignType === MarketingCampaignType.ClientRebate) {
    return [
      {
        name: IbContestInternalResultsFilterKey.clientName,
        label: 'Client Name',
        filter: TextFilter,
        operators: [
          {
            text: GridFilterOperatorNameEnum.equalOperator,
            operator: GridFilterOperatorEnum.equalOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notEqOperator,
            operator: GridFilterOperatorEnum.notEqOperator,
          },
          {
            text: GridFilterOperatorNameEnum.likeOperator,
            operator: GridFilterOperatorEnum.likeOperator,
          },
          {
            text: GridFilterOperatorNameEnum.notLikeOperator,
            operator: GridFilterOperatorEnum.notLikeOperator,
          },
        ],
      },
    ]
  }
  return [
    {
      name: IbContestInternalResultsFilterKey.ibCode,
      label: 'IB Code',
      filter: TextFilter,
      operators: [
        {
          text: GridFilterOperatorNameEnum.equalOperator,
          operator: GridFilterOperatorEnum.equalOperator,
        },
        {
          text: GridFilterOperatorNameEnum.notEqOperator,
          operator: GridFilterOperatorEnum.notEqOperator,
        },
        {
          text: GridFilterOperatorNameEnum.likeOperator,
          operator: GridFilterOperatorEnum.likeOperator,
        },
        {
          text: GridFilterOperatorNameEnum.notLikeOperator,
          operator: GridFilterOperatorEnum.notLikeOperator,
        },
      ],
    },
    {
      name: IbContestInternalResultsFilterKey.clientName,
      label: 'Client Name',
      filter: TextFilter,
      operators: [
        {
          text: GridFilterOperatorNameEnum.equalOperator,
          operator: GridFilterOperatorEnum.equalOperator,
        },
        {
          text: GridFilterOperatorNameEnum.notEqOperator,
          operator: GridFilterOperatorEnum.notEqOperator,
        },
        {
          text: GridFilterOperatorNameEnum.likeOperator,
          operator: GridFilterOperatorEnum.likeOperator,
        },
        {
          text: GridFilterOperatorNameEnum.notLikeOperator,
          operator: GridFilterOperatorEnum.notLikeOperator,
        },
      ],
    },
    {
      name: IbContestInternalResultsFilterKey.country,
      label: 'Country',
      filter: MultiCountrySelectFilter,
      operators: [
        {
          text: GridFilterOperatorNameEnum.equalOperator,
          operator: GridFilterOperatorEnum.equalOperator,
        },
        {
          text: GridFilterOperatorNameEnum.notEqOperator,
          operator: GridFilterOperatorEnum.notEqOperator,
        },
      ],
    },
  ]
}
